"use strict";
/**
 * "Correcting the Eskom Charges Displayed in the Services for Bulk Electricity", point 5.
 *
 * Erik: "the rates (numbers) are correct, and the charge formulae are correct, however, the monetary
 * unit assigned in front of the charges are incorrect … change the monetary units of the unit amount to
 * match the monetary units in the charge formula."
 *
 * Every screen printed a literal "R" in front of `rateValue`, whatever the charge's unit of measure
 * said. Eskom publishes energy components in CENTS (c/kWh, c/kVArh) and capacity/fixed components in
 * RANDS (R/kVA/month, R/POD/day), so half the rows were labelled with the wrong currency — a network
 * demand charge of 32.3 c/kWh rendered as "R32.3000", a hundredfold overstatement to anyone reading it.
 *
 * **The number itself is not converted, and must not be.** The stored value is exactly what the tariff
 * publishes, and billing is the proof: `chargeCalculator.ts` calls `centsToRands()` — a plain ÷100 — on
 * precisely the components the materialiser tags `c/…`. So 32.3 IS 32.3 cents; it needs the right
 * label, not different arithmetic. (Erik's worked example in the ticket, "R 32.3000 becomes 0.3230 c",
 * divides by 100 *and* relabels, which would make the screen disagree with the bill. His very next line
 * — "network cap and generation cap stays the same" — only holds for a label-only fix, since a real
 * conversion would move those too.)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyOfUnit = currencyOfUnit;
exports.formatChargeRate = formatChargeRate;
/**
 * Reads the currency off the unit of measure — "c/kWh" → cents, "R/kVA/month" → rands.
 *
 * Falls back to rands when the unit is missing or unrecognised: that is the pre-existing behaviour, so
 * a charge with a hand-typed unit renders exactly as it did before rather than silently changing.
 */
function currencyOfUnit(unitMeasure) {
    return /^\s*c\s*\//i.test(unitMeasure !== null && unitMeasure !== void 0 ? unitMeasure : "") ? "c" : "R";
}
/**
 * Formats a charge rate with the currency its unit implies.
 *
 * `decimals` defaults to 4 because Eskom rates carry four (32.3000 c/kWh); pass 2 where a screen was
 * already showing two and the extra precision would be noise.
 */
function formatChargeRate(rateValue, unitMeasure, decimals) {
    if (decimals === void 0) { decimals = 4; }
    if (rateValue == null)
        return "—";
    var amount = rateValue.toFixed(decimals);
    return currencyOfUnit(unitMeasure) === "c" ? "".concat(amount, "c") : "R".concat(amount);
}
